export default __webpack_public_path__ + "static/2152-9fa9c7a830e98096819bd7badc9767e6.gif";